@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

@layer design-system {
  .showMoreButton {
    display: none;
    position: absolute;
    background: linear-gradient(
      to left,
      rgba(var(--background-default-rgb), 1) 0%,
      rgba(var(--background-default-rgb), 0) 286.65%
    );
    right: 8px;
    border: 1px solid var(--border-soft);
    padding: 4px;

    svg {
      transform: rotate(90deg);
    }
  }

  .styledDropdownListItem {
    margin: 8px;

    &:focus-visible {
      outline: 2px solid var(--border-focus);
    }

    &::before {
      background-color: none;
    }
  }

  .styledPillContainer {
    display: inline-flex;
    width: fit-content;
    justify-content: center;
    align-items: center;
  }

  .pillDropdownRoot {
    @include border-radius-r2;
    @include typography-v2-body-sm;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    color: var(--text-default);
    padding: 4px;
    gap: 8px;
    outline: none;
    position: relative;

    &.default {
      background-color: transparent;
      border: 1px solid transparent;
    }

    &.outline {
      background-color: var(--surface-default);
      border: 1px solid transparent;
    }

    &.buttonPrimary {
      background-color: transparent;
      border: 1px solid var(--border-primary);
      color: var(--text-primary);
      padding: 8px 12px;
      @include border-radius-r1;

      .label {
        text-transform: none;
      }
    }

    &.interactive {
      &.default {
        cursor: pointer;

        &:hover,
        &:focus-visible {
          background-color: var(--surface-hover);
        }
      }

      &.outline {
        cursor: pointer;

        &:hover,
        &:focus-visible {
          border: 1px solid var(--border-hover);
        }
      }

      &.buttonPrimary {
        cursor: pointer;
      }
    }

    &.hasOptions {
      &:focus-visible {
        outline: 2px solid var(--border-focus);
      }

      &:hover,
      &:focus-within {
        .showMoreButton {
          display: flex;
        }
      }
    }
  }

  .label {
    @include typography-v2-body-sm;
    display: flex;
    align-items: center;
    flex-direction: row;
    margin: 0 4px;
    text-wrap: wrap;
  }

  .styledPillDropdown {
    min-width: 50px;
    width: fit-content;

    [data-dropdown-list] {
      width: 288px;
      white-space: nowrap;
      max-height: 264px;
      overflow: auto;
    }
  }
}
